import { render } from "./FormSection.vue?vue&type=template&id=708e9ffd&ts=true"
import script from "./FormSection?vue&type=script&lang=ts&external"
export * from "./FormSection?vue&type=script&lang=ts&external"

import "./FormSection.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__